import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {BindingConfig, BindingIconPlace, BindingTooltipPlace} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {ANumberConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ANumberConfig';
import * as React from 'react';
import {CSSProperties} from 'react';

export class OpacityModel
{
    @Property<ABoolean>({
        title: 'Opacity enabled',
        tip: 'Opacity enabled',
        isRequired: true,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with(null, BindingIconPlace.RightMiddle, BindingTooltipPlace.Right)
    })
    isEnabled:ABoolean;

    @Property<ANumber>({
        title: 'Scale',
        tip: `Scale`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    opacity:ANumber;

    public constructor(isEnabled:ABoolean,
                       opacity:ANumber)
    {
        this.isEnabled = isEnabled;
        this.opacity = opacity;
    }

    public static default():OpacityModel
    {
        return new OpacityModel(
            ABoolean.false(),
            ANumber.fromNumber(1)
        );
    }

    public toCss():CSSProperties
    {
        if( this.isEnabled && this.isEnabled.value && this.opacity.value !== 1 )
            return {
                opacity: this.opacity.value
            };

        return null;
    }
}
